import { BaladaApp } from '@/model';
import {
  GetBaladaAppByIdResponse,
  GetBaladaAppItemResponse,
  GetBaladaAppResponse,
  PostBaladaAppResponse,
  PutBaladaAppResponse,
} from '@/services/response/balada-app';

export class BaladaAppConverter {
  static toDomainFromGetItemResponse(response: GetBaladaAppItemResponse): BaladaApp {
    return {
      uuid: response.uuid,
      title: response.title,
      identifier: response.identifier,
      type: response.type,
      image_url: response.image_url,
      source_url: response.source_url,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetBaladaAppResponse): BaladaApp[] {
    return response.data.map(BaladaAppConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetBaladaAppByIdResponse): BaladaApp {
    return BaladaAppConverter.toDomainFromGetItemResponse(response);
  }

  static toDomainFromPostResponse(response: PostBaladaAppResponse): BaladaApp {
    return BaladaAppConverter.toDomainFromGetItemResponse(response);
  }

  static toDomainFromPutResponse(response: PutBaladaAppResponse): BaladaApp {
    return BaladaAppConverter.toDomainFromGetItemResponse(response);
  }
}
